// Which of a new user's workspace assignments becomes their `default_id_client`
// — the workspace they land on at login.
//
// The provisioning modals let an admin add and remove assignment rows freely, and
// a row exists with no workspace chosen while it is still being filled in. Both
// the modals and the payload builders resolve the default through here, so a
// removed or re-pointed row can never submit a default the user was not granted.

/** Workspace ids from assignment rows that have one, in row order. */
export const assignedWorkspaceIds = (assignments = []) =>
  (assignments || []).map((a) => a?.workspaceId).filter(Boolean);

/**
 * The admin's pick when it is still assigned, else the first assigned workspace.
 * Null when nothing is assigned yet.
 */
export const resolveDefaultWorkspace = (assignments = [], chosen = null) => {
  const assigned = assignedWorkspaceIds(assignments);
  if (chosen && assigned.includes(chosen)) return chosen;
  return assigned.length > 0 ? assigned[0] : null;
};
